import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

const NewsListPage = () =>
  import('@modules/news/components/news-list-page.vue');
const NewsFormPage = () =>
  import('@modules/news/components/news-form-page.vue');
const NewsViewPage = () =>
  import('@modules/news/components/news-view-page.vue');
const NewsImporterPage = () =>
  import('@modules/news/components/news-importer-page.vue');

export default [
  {
    name: '',
    path: '',
    component: Layout,
    meta: { auth: true },
    children: [
      {
        name: 'news',
        path: '/news',
        component: NewsListPage,
        meta: {
          auth: true,
          permission: Permissions.values.newsView,
        },
      },
      {
        name: 'newsNew',
        path: '/news/new',
        component: NewsFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.newsCreate,
        },
      },
      {
        name: 'newsImporter',
        path: '/news/import',
        component: NewsImporterPage,
        meta: {
          auth: true,
          permission: Permissions.values.newsImport,
        },
      },
      {
        name: 'newsEdit',
        path: '/news/:id/edit',
        component: NewsFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.newsEdit,
        },
        props: true,
      },
      {
        name: 'newsView',
        path: '/news/:id',
        component: NewsViewPage,
        meta: {
          auth: true,
          permission: Permissions.values.newsView,
        },
        props: true,
      },
    ],
  },
];
